var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"text-center thumbnail-container"},[_c('b-col',{attrs:{"sm":"12"}},[_c('p',[_vm._v("Please wait while page loads...")]),_c('img',{attrs:{"src":require("@/assets/loading-trans.gif"),"width":"50"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b205c300","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/LoadingIndicator.vue
// module id = null
// module chunks = 